import { all } from 'redux-saga/effects';

import config from './configPwa';
console.log("indexPwa sagas Started")
export default function* rootSaga() {
  yield all([
    config() 
  ]);
}
